import { h } from 'preact';
import Page from 'components/pages/page';
import HTML from 'components/core/html/html';
import s from 'components/pages/hostAScreening/hostAScreening.sss';

export default class HostAScreening extends Page {

	//RENDER METHODS
	//----------------------------------------
	render({ pageData, appData }){

		const { googleFormID, pageImage } = pageData;
		const imgRoot = this.props.appData.urls.roots.image;
		const {
			title,
			subtitle,
			body,
			body2,
			cta
		} = pageData.copy;
		let iframe, label;
		if (pageData.googleFormID) {
			if (cta) {
				label = (
					<label class={s.body} for="google-form">
						{cta}
					</label>
				);
			}
			iframe = (
				<iframe
					id="google-form"
					class={s.iframe}
					src={`https://docs.google.com/forms/d/e/${googleFormID}/viewform?embedded=true`}
					// width="100%"
					// height="100%"
					frameborder="0"
				/>
			);
		}

		return (
			<article class={s.container}>
				<header class={s.header}>
					<h1 class={s.title}>
						{title}
					</h1>
					<HTML class={s.subtitle} content={subtitle} markdown />
					{pageImage && <img class={s.img} src={`${imgRoot}/${pageImage}`} alt="" />}
					<HTML class={s.body} content={body} markdown />
					{label}
				</header>
				<img src={`${imgRoot}/arrow_down.svg`} class={s.downArrow}/>
				<div class={s.content}>
					{iframe}
					<HTML class={s.body2} content={body2} markdown />
				</div>
			</article>
		);
	}//render
}
